import gql from 'graphql-tag';

const USER_LOGIN = gql`
  mutation userLogin($email: Email!, $password: Password!) {
    userLogin(email: $email, password: $password) {
      token
      user {
        id
        name
        email
        role
      }
    }
  }
`;

export default USER_LOGIN;
